// this should take in the user list from the userlistSlice
// NOT the subscriptionUserList from conversationsSlice

// eslint-disable-next-line import/prefer-default-export
export const getFullUserName = (userId, users) => {
  const user = users && users.find((u) => Number(u.userId) === userId);
  if (user) {
    const { firstName, lastName } = user;
    return `${firstName || ''} ${lastName || ''}`;
  }
  return 'Unknown User';
};
